/* SoloDads Dawn - small, dependency-free behaviours. */
(() => {
  const hasIO = 'IntersectionObserver' in window;

  // Header turns solid once the page scrolls off the first scene.
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Fade sections in as they enter the viewport.
  const revealEls = document.querySelectorAll('.reveal');
  if (hasIO) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add('is-in'));
  }

  // Close the mobile menu after following an in-page link.
  document.querySelectorAll('.mobile-menu a').forEach((link) => {
    link.addEventListener('click', () => link.closest('details').removeAttribute('open'));
  });

  // Keep every price label in sync with the chosen variant.
  document.querySelectorAll('[data-product-form]').forEach((form) => {
    form.addEventListener('change', (event) => {
      const radio = event.target.closest('input[name="id"][data-price]');
      if (!radio) return;
      document.querySelectorAll('[data-buy-price]').forEach((el) => { el.textContent = radio.dataset.price; });
    });
  });

  // Mobile buy bar shows whenever the main buy button is out of view, above or below,
  // so the price and the button are always one tap away.
  const bar = document.querySelector('[data-buybar]');
  const buyButton = document.querySelector('[data-buy-button]');
  if (bar && buyButton && hasIO) {
    const barButton = bar.querySelector('button');
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', String(!show));
      if (barButton) barButton.tabIndex = show ? 0 : -1;
    }).observe(buyButton);
  }

  // Product gallery: thumbnails switch the stage between book, phone and photos.
  document.querySelectorAll('[data-gallery]').forEach((gallery) => {
    const slides = gallery.querySelectorAll('[data-slide]');
    const thumbs = gallery.querySelectorAll('[data-thumb]');
    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        slides.forEach((slide, i) => { slide.hidden = i !== index; slide.classList.toggle('is-active', i === index); });
        thumbs.forEach((t, i) => { t.classList.toggle('is-active', i === index); t.setAttribute('aria-pressed', String(i === index)); });
      });
    });
  });

  // Background videos load only when their scene is about to be seen, and never
  // for visitors who ask for reduced motion or lighter data use.
  const lazyVideos = document.querySelectorAll('[data-lazy-video]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const saveData = navigator.connection && navigator.connection.saveData;
  if (lazyVideos.length && hasIO && !reduceMotion && !saveData) {
    const videoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting) {
          if (!video.src) {
            video.src = window.innerWidth < 750 ? video.dataset.srcMobile : video.dataset.src;
            video.addEventListener('playing', () => video.classList.add('is-playing'), { once: true });
          }
          video.play().catch(() => {});
        } else if (video.src) {
          video.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    lazyVideos.forEach((video) => videoObserver.observe(video));
  }

  // Dad check-in: show the matching recommendation and tag the signup.
  document.querySelectorAll('[data-checkin]').forEach((root) => {
    const tags = root.querySelector('[data-tags]');
    root.addEventListener('change', (event) => {
      const answer = event.target.closest('[data-answer]');
      if (!answer) return;
      root.querySelectorAll('[data-result]').forEach((result) => {
        result.hidden = result.dataset.result !== answer.dataset.answer;
      });
      if (tags) tags.value = `newsletter,checkin,situation-${answer.value}`;
    });
  });
})();
